module.exports = __webpack_public_path__ + "static/media/Shillan Kisten.b5f65e62.jpg";